module.exports = __webpack_public_path__ + "static/media/bn_banner.a85675e5.png";